var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteProcedure(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "51px",
    height: "31px",
    viewBox: "0 0 51 31",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Delete") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M21.5177797,9.56897654 L21.084359,9.56897654 L3.74752914,9.56897654 L3.31410839,9.56897654 C2.59723048,9.56897654 2.01384615,8.98559222 2.01384615,8.26871431 C2.01384615,7.55183639 2.59723048,6.96845207 3.31410839,6.96845207 L8.0817366,6.96845207 L16.7501515,6.96845207 L21.5177797,6.96845207 C22.2346576,6.96845207 22.818042,7.55183639 22.818042,8.26871431 C22.818042,8.98559222 22.2346576,9.56897654 21.5177797,9.56897654 L21.5177797,9.56897654 Z M20.2175175,25.1721234 C20.2175175,25.6506199 19.8291725,26.0389649 19.350676,26.0389649 L5.48121212,26.0389649 C5.00271562,26.0389649 4.61437063,25.6506199 4.61437063,25.1721234 L4.61437063,11.3026595 L20.2175175,11.3026595 L20.2175175,25.1721234 Z M12.4159441,1.76740312 C14.3281964,1.76740312 15.88331,3.32251675 15.88331,5.23476909 L8.94857809,5.23476909 C8.94857809,3.32251675 10.5036917,1.76740312 12.4159441,1.76740312 L12.4159441,1.76740312 Z M24.5517249,8.26871431 C24.5517249,6.59571023 23.1907838,5.23476909 21.5177797,5.23476909 L17.616993,5.23476909 C17.616993,2.36639059 15.2843226,0.033720134 12.4159441,0.033720134 C9.54756556,0.033720134 7.2148951,2.36639059 7.2148951,5.23476909 L3.31410839,5.23476909 C1.64110431,5.23476909 0.28016317,6.59571023 0.28016317,8.26871431 C0.28016317,9.79348849 1.41485868,11.0460744 2.88068765,11.2584506 L2.88068765,25.1721234 C2.88068765,26.6058792 4.04745629,27.7726479 5.48121212,27.7726479 L19.350676,27.7726479 C20.7844318,27.7726479 21.9512005,26.6058792 21.9512005,25.1721234 L21.9512005,11.2584506 C23.4170294,11.0460744 24.5517249,9.79348849 24.5517249,8.26871431 L24.5517249,8.26871431 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-41.2%",
    y: "-28.8%",
    width: "182.4%",
    height: "172.1%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.4 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.0817366,22.5715989 C7.60237325,22.5715989 7.2148951,22.1841208 7.2148951,21.7047574 L7.2148951,14.7700255 C7.2148951,14.2906622 7.60237325,13.903184 8.0817366,13.903184 C8.56109994,13.903184 8.94857809,14.2906622 8.94857809,14.7700255 L8.94857809,21.7047574 C8.94857809,22.1841208 8.56109994,22.5715989 8.0817366,22.5715989",
    id: "path-3"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-490.3%",
    y: "-75.0%",
    width: "1080.6%",
    height: "296.1%",
    filterUnits: "objectBoundingBox",
    id: "filter-4"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.3 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12.4159441,22.5715989 C11.9365807,22.5715989 11.5491026,22.1841208 11.5491026,21.7047574 L11.5491026,14.7700255 C11.5491026,14.2906622 11.9365807,13.903184 12.4159441,13.903184 C12.8953074,13.903184 13.2827855,14.2906622 13.2827855,14.7700255 L13.2827855,21.7047574 C13.2827855,22.1841208 12.8953074,22.5715989 12.4159441,22.5715989",
    id: "path-5"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-490.3%",
    y: "-75.0%",
    width: "1080.6%",
    height: "296.1%",
    filterUnits: "objectBoundingBox",
    id: "filter-6"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.3 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M16.7501515,22.5715989 C16.2707882,22.5715989 15.88331,22.1841208 15.88331,21.7047574 L15.88331,14.7700255 C15.88331,14.2906622 16.2707882,13.903184 16.7501515,13.903184 C17.2295149,13.903184 17.616993,14.2906622 17.616993,14.7700255 L17.616993,21.7047574 C17.616993,22.1841208 17.2295149,22.5715989 16.7501515,22.5715989",
    id: "path-7"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-490.3%",
    y: "-75.0%",
    width: "1080.6%",
    height: "296.1%",
    filterUnits: "objectBoundingBox",
    id: "filter-8"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.3 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Delete",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11-Copy",
    transform: "translate(12.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Delete",
    transform: "translate(0.700000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fill-226"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill-227"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-4)",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill-228"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-6)",
    xlinkHref: "#path-5"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill-229"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-8)",
    xlinkHref: "#path-7"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-7"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteProcedure);
export default __webpack_public_path__ + "static/media/Delete_procedure.c9b0286fb35d4a46517145dfc5a7649a.svg";
export { ForwardRef as ReactComponent };